var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "sidecart-line-item-kit" },
    [
      _c(
        "div",
        { staticClass: "sidecart-line-item-kit__heading" },
        [
          _c("h5", { staticClass: "sidecart-line-item-kit__h5" }, [
            _vm._v(_vm._s(_vm.getKitLineItemHeader(_vm.kit.items)))
          ]),
          _c("icon", {
            staticClass: "sidecart-line-item-kit__remove",
            attrs: { name: "close", size: "16px" },
            on: { click: _vm.removeKit }
          })
        ],
        1
      ),
      _vm._l(_vm.kit.items, function(item, index) {
        return _c("cart-line-item", {
          key: item.id,
          attrs: {
            item: item,
            line: index + 1,
            "kit-id": item.properties_kitId,
            "disable-remove": "",
            "disable-quantity": "",
            "in-kit": ""
          }
        })
      })
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }